import { createSelector } from 'reselect';
import { initialState } from '.';
import { RootState } from 'types';
import uniq from 'lodash/uniq';
import flattenDeep from 'lodash/flattenDeep';

const stateLoginPage = (state: RootState) => state.login || initialState;

export const login = createSelector(stateLoginPage, (res) => {
  return res;
});

export const selectorInfoProfile = createSelector(stateLoginPage, (info) => {
  return info.infoProfile;
});

export const selectorPermissionUser = createSelector(
  stateLoginPage,
  ({ infoProfile }) => {
    return uniq(
      flattenDeep(infoProfile?.roles?.map((item) => item.permissions))?.map(
        (item) => item.name
      )
    );
  }
);
